define(
    'C3.ShoppingExtensions.ReceiveUpdates.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function ReceiveUpdatesModel() {
            SCModel.call(this);

            // Define properties of the model.
            this.urlRoot = function() {
                return Utils.getAbsoluteUrl(
                    getExtensionAssetsPath("services/ReceiveUpdates.Service.ss")
                )
            }

            this.validation = function (){
                return {
                        firstname: {
                        required: true,
                        msg: Utils.translate('First Name is Required')
                         },
                        lastname: {
                            required: true,
                            msg: Utils.translate('Last Name is Required')
                        },
                        custentity_destination_country: {
                                fn: function(val) {
                                   //console.log(val)
                                   if(val == 'Select one' || val == undefined)
                                    return Utils.translate('Country is Required');
                                }
                            },
                        custentity_customer_state: {
                             fn: function(value,name,form) {
                               //console.log(form.custentity_destination_country)

                               if(form.custentity_destination_country != undefined && (form.custentity_customer_state == undefined || form.custentity_customer_state == 'Select one'))
                                return Utils.translate('State is Required');                  
                            }
                        },
                        email: [
                            {
                                required: true,
                                msg: 'Email Address is Required'
                            },
                            {
                                pattern: 'email',
                                msg: 'Valid email address is required'
                            }
                        ]/*,
                        backinstock: {
                            fn: function(value,name,form) {
                               //if((form.backinstock == false || form.backinstock == undefined) && (form.lowinventory == false || form.lowinventory == undefined) && (form.pricedrop == false || form.pricedrop == undefined))
                               if(form.backinstock == false || form.backinstock == undefined)
                               {
                                console.log(form)
                                return Utils.translate('Atleast 1 Option is Required'); 
                                }                             
                            }
                        }*/
                }
            }
        }

        ReceiveUpdatesModel.prototype = Object.create(SCModel.prototype);

        ReceiveUpdatesModel.prototype.constructor = ReceiveUpdatesModel;

        // Return the AMD constructor.
        return ReceiveUpdatesModel;
    }
);
